export default __webpack_public_path__ + "static/media/appqr_code.cc33d1d3.jpg";